import config from '../constants/config';
import { useContractRead } from 'wagmi';
import { useEffect, useMemo, useState } from 'react';

const useHoneyJarsInWallet = (
  walletAddress?: string
): [tokenIds: number[] | undefined, read: () => void] => {
  const [tokensInWallet, setNftsInWallet] = useState<number[]>();

  const { data, refetch } = useContractRead({
    addressOrName: config.contracts.honeyJarsContract.address,
    contractInterface: config.contracts.honeyJarsContract.interface,
    functionName: 'tokensInWallet',
    args: walletAddress,
  });

  useEffect(() => {
    if (data) {
      setNftsInWallet(data?.map(bn => bn.toNumber() as number));
    }
  }, [data]);

  return useMemo(() => [tokensInWallet, refetch], [tokensInWallet, refetch]);
};

export default useHoneyJarsInWallet;
